import { createSlice } from "@reduxjs/toolkit";
import { getProductReportData } from "./ThunkAction";
import { ProFormaInvoce } from "./Types";

const initialState: ProFormaInvoce = {
  productDetail: [],
  dataList: [], 
  loadingList: false, 
  loadingDataList: false, 
  message: null,
  error: null,
  loading: false
};

const productReportSlice = createSlice({
  name: "productReportState",
  initialState,
  reducers: {
    clearProductReportData: (state) => {
      state.productDetail = [];
      state.loadingList = false;
      state.loadingDataList = false;
      state.message = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
       builder
      .addCase(getProductReportData.pending, (state) => {
        state.loadingDataList = true;
        state.error = null;
      })
      .addCase(getProductReportData.fulfilled, (state, action) => {
        state.loadingDataList = false;
        state.dataList = action.payload?.data || [];
        state.message = action.payload?.message || null;
      })
      .addCase(getProductReportData.rejected, (state, action) => {
        state.loadingDataList = false;
        
        state.error = action.payload?.message || "Something went wrong";
      });
  },
});

export const { clearProductReportData } = productReportSlice.actions;
export default productReportSlice.reducer;
